"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

var _feedback_list = require("@/api/feedback_list");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      feedbackList: null,
      listLoading: true
    };
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.listLoading = true;
      (0, _feedback_list.getList)().then(function (response) {
        var feedbackList = response.data;
        console.log(feedbackList);
        feedbackList.map(function (item, index) {
          feedbackList[index]['img'] = item.img_list.split('$$$')[0];
        }); // catList.reverse()

        _this.feedbackList = feedbackList;
        _this.listLoading = false;
      });
    },
    handleLink: function handleLink(id) {
      this.$router.push("/feedback/edit/".concat(id));
    },
    filterStatusHandler: function filterStatusHandler(value, row, column) {
      console.log(value);
      return row.status === value;
    },
    filterOnlineHandler: function filterOnlineHandler(value, row, column) {
      return row.online === value;
    },
    filterReserveHandler: function filterReserveHandler(value, row, column) {
      return row.reserve === value;
    }
  }
};
exports.default = _default;